<template>
  <div 
    class="height-all" 
    @mousedown.stop="handleMouseDown"
    @touchstart.stop="handleMouseDown"
  >
    <router-view v-if="showRouter"></router-view>
    <div class="lottie-animation-contaniner" v-if="renderData.showLoader">
      <div class="lottie-animation-content">
        <LottieAnimation />
      </div>
    </div>
  </div>
</template>
<script setup>
import { watch, reactive, onMounted, ref} from "vue"
import i18n from "@/i18n/i18n.js"
import tools from "@/utils/tools.js"
import useUserDataStore from "@/store/userDataStore"
import GlobalConfig from "@/config/config.js"
import { getCookie } from "@/utils/cookie.js"
import { jsBridge } from "@/utils/jsBridge.js"
import apiUser from "@/api/api/apiUser.js"
import router from "@/router/index.js";
import GlobalAudioPlayer from '@/components/media/audioPlayer/GlobalAudioPlayer.js'
import LottieAnimation from '@/components/animation/LottieAnimation.vue'
const extendRouterMethods = ()=>{
  ['push','replace','go','back', 'forward'].forEach((method) => {
    let source = router[method]
    router[method] =  (...arg)=> {
      if(typeof arg[0] === 'object'){
        arg[0].query = {
           ...arg[0].query,
           immersive:1
        }
      }
      GlobalAudioPlayer.pause(GlobalAudioPlayer.currentUrl)
      if (
        method === "push" &&
        arg[0]?.name != "skywork" &&
        arg[0]?.path != "home"
      ) {
        renderData.showLoader = true;
      }
      source.apply(router, arg)
    }
  })
}

router.beforeEach((to, from, next) => {
  let focusedElement = document.activeElement;
  // 判断当前是否有聚焦的输入元素
  if (focusedElement) {
    focusedElement.blur();
    nextTick().then(()=>{
      next();
    })
  } else {
    next();
  }
})

router.afterEach((to, from) => {
  to.matched.forEach(record => {
    // const component = record.instances.default;
    // 检查路由组件是否存在并且是否已经挂载
    // if (component && component.$el) {
      renderData.showLoader = false;
    // }
  });
});


const showRouter = ref(false)
const renderData = reactive({
  showLoader: false,
})
const userDataStore = useUserDataStore()
let k_sso_token = getCookie("k_sso_token") ?? ""
console.log("k_sso_token初始", k_sso_token)
const registCacheData = (_this) => {
  document.addEventListener("visibilitychange", function () {
    //浏览器切换事件
    if (document.visibilityState == "hidden") {
      if((router.currentRoute.value.name == 'shareLand' || router.currentRoute.value.name == 'shareLanding') && tools.getUrlAllParams(decodeURIComponent(location.href)).offsite==1){
        return
      }
      GlobalAudioPlayer.pause(GlobalAudioPlayer.currentUrl)
    }
  })
  // window.onbeforeunload = () => {
  //   localStorage.setItem(GlobalConfig.localStorageGlobalKey, JSON.stringify(userDataStore.getAll()))
  // }
}

const handleMouseDown = (event)=>{
  const x = event.clientX ?? event.touches[0].clientX; // 获取点击点的水平坐标
  const screenWidth = window.innerWidth; // 获取浏览器窗口的宽度
  const margin = 16; // 边缘距离
  if (x <= margin) {
    doBlur(event)
  }
  if (screenWidth - x <= margin) {
   doBlur(event)
  }
}

const doBlur = (event)=>{
  let focusedElement = window.__lastInput;
  if (focusedElement) {
    focusedElement.blur();
    window.__lastInput = null;
  }
  let focusedElementG = document.activeElement;
  if (focusedElementG) {
    focusedElementG.blur();
  }
}

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    if (userDataStore.appLanguage == "cn") {
      i18n.global.locale = "cn"
    } else {
      i18n.global.locale = "en"
    }
    return
  },
  {
    immediate: true,
    deep: true,
  }
)

function isCurrentRouteSkywork() {
  return window.location.pathname === "/skywork" || window.location.pathname === "/"
}

const loginstate = () => {
  if (isCurrentRouteSkywork()) {
    showRouter.value = true
    return
  }

  if (!k_sso_token) {
    userDataStore.updateLoginStatus(false)
    userDataStore.clearAll(false)
    showRouter.value = true
    return
  }

  const isTokenMatch = k_sso_token === userDataStore.k_sso_token
  if (isTokenMatch) {
    console.log("isTokenMatch")
    userDataStore.updateLoginStatus(true)
    showRouter.value = true
    return
  }

  userDataStore.clearAll()
  userDataStore.k_sso_token = k_sso_token

  apiUser
    .userLogin({ mode: "tiangong", token: k_sso_token })
    .then((res) => {
      console.log("登录信息1", res)
      const isLoginSuccessful = res.code === 200
      userDataStore.updateLoginStatus(isLoginSuccessful)
      if (isLoginSuccessful) {
        userDataStore.upDataAuthData(res.data.auth)
      }
      showRouter.value = true
    })
    .catch((error) => {
      console.error("登录失败", error)
      userDataStore.updateLoginStatus(false)
      showRouter.value = true
    })
}
loginstate()

onMounted(() => {
 registCacheData()
 extendRouterMethods()
  
  // window.addEventListener(
  //   "loginState",
  //   (event) => {
  //     console.log("监听天工登录", event?.detail)
  //     if (event.detail?.isLogin) {
  //       k_sso_token = getCookie("k_sso_token") ?? ""
  //       console.log("k_sso_token改变", k_sso_token)
  //       loginstate()
  //     } else {
  //       console.log("退出登录清空信息")
  //       userDataStore.clearAll()
  //     }
  //   },
  //   false
  // )
})
</script>
<style lang="scss">
.lottie-animation-contaniner{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .lottie-animation-content{
    height: 80px;
    width: 80px;
  }
}
</style>
